module.exports = __webpack_public_path__ + "img/santander@2x.a0b8efe.png";